// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__2WTbO","externalId":"style_externalId__fsIqP"};